export class List<T> {
  protected target: T[];

  constructor() {
    this.target = [];
  }

  public get(): T[] {
    return this.target;
  }

  public add(value: T): void {
    if (!this.target.includes(value)) {
      this.target.push(value);
    }
  }

  public remove(value: T): void {
    if (this.target.includes(value)) {
      const index = this.target.indexOf(value);
      this.target.splice(index, 1);
    }
  }
}
